<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-md mb-5 mb-md-0">
                <h2
                    class="m-0"
                    v-text="userForm.displayName"
                />
            </div>
            <div class="col-xs-12 col-md text-left text-md-right">
                <el-button
                    v-if="$route.query.mode && 'edit' === $route.query.mode"
                    :disabled="saving"
                    round
                    icon="el-icon-back"
                    size="small"
                    @click="$router.push({name: 'users'})"
                >
                    {{ $t("common.back") }}
                </el-button>
                <el-button
                    :disabled="saving"
                    type="primary"
                    round
                    size="small"
                    icon="el-icon-s-claim"
                    @click="submitForm"
                >
                    {{ $t("common.save") }}
                </el-button>
            </div>
        </div>

        <el-divider />

        <el-form
            ref="newDemandForm"
            :disabled="saving"
            :model="userForm"
            :rules="rules"
            label-position="top"
        >
            <div class="row">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item
                        :label="$t('view.profile.display_name')"
                        prop="displayName"
                    >
                        <el-input
                            v-model="userForm.displayName"
                            :placeholder="$t('view.profile.display_name_placeholder')"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item :label="$t('view.profile.email_address')">
                        <el-input
                            v-model="userForm.email"
                            :readonly="true"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item :label="$t('view.profile.notification_method')">
                        <el-switch
                            v-model="userForm.notificationMethod"
                            style="display: block"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-text="$t('view.profile.sms')"
                            :inactive-text="$t('view.profile.push_notification')"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item
                        :label="$t('view.profile.phone_number')"
                        prop="phoneNumber"
                    >
                        <el-input
                            v-model="userForm.phoneNumber"
                            v-mask="['+3069########']"
                            :placeholder="$t('view.profile.phone_number_placeholder')"
                        />
                    </el-form-item>
                </div>
            </div>

            <div
                v-if="isUserAdmin && $route.params.id !== getUserID"
                class="row"
            >
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item :label="$t('view.profile.role')">
                        <el-select
                            v-model="userForm.role"
                            :placeholder="$t('view.profile.role')"
                            style="width: 100%"
                        >
                            <el-option
                                :value="'agent'"
                                :label="$t('view.profile.role_partner')"
                            ></el-option>
                            <el-option
                                :value="'administrator'"
                                :label="$t('view.profile.role_administrator')"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>

        </el-form>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {mask}                             from "vue-the-mask";

export default {
    name: "DemandChat",
    head() {
        return {
            title: {
                inner: "."
            }
        };
    },
    directives: {
        mask
    },
    data      : () => (
        {
            saving  : false,
            userForm: {
                displayName       : "",
                email             : "",
                id                : "",
                role              : "",
                notificationMethod: "",
                phoneNumber       : ""
            }
        }
    ),
    computed  : {
        ...mapState(
            "authentication",
            [
                "user"
            ]
        ),
        ...mapGetters(
            "authentication",
            [
                "isUserAdmin",
                "getUserID"
            ]
        ),
        rules() {
            return {
                displayName: [
                    {
                        required: true,
                        message : this.$t("view.profile.required_field"),
                        trigger : "blur"
                    }
                ],
                phoneNumber: [
                    {
                        required: true,
                        message : this.$t("view.profile.required_field"),
                        trigger : "blur"
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!/^\+3069\d{8}$/.test(value)) {
                                callback(this.$t("view.profile.phone_number_format_validation"));
                            } else {
                                callback();
                            }
                        },
                        trigger  : "blur"
                    }
                ]
            };
        }
    },
    async mounted() {
        if (this.$route.params.id !== this.user.id && !this.isUserAdmin) {
            this.$router.push(
                {
                    name: "dashboard"
                }
            );
        }

        await this.getUsersAction();

        if (this.$route.params.id === this.user.id) {
            this.userForm.displayName        = typeof undefined === typeof this.user.displayName ? null : this.user.displayName;
            this.userForm.email              = typeof undefined === typeof this.user.email ? null : this.user.email;
            this.userForm.id                 = typeof undefined === typeof this.user.id ? null : this.user.id;
            this.userForm.role               = typeof undefined === typeof this.user.role ? null : this.user.role;
            this.userForm.notificationMethod =
                typeof undefined === typeof this.user.notificationMethod ? false : this.user.notificationMethod;
            this.userForm.phoneNumber        =
                typeof undefined === typeof this.user.phoneNumber ? "" : this.user.phoneNumber;

            const title    = document.title.split(" | ");
            title[0]       = this.userForm.displayName;
            document.title = title.join(" | ");
        } else if (this.isUserAdmin) {
            const user                       = await this.getUserAction(this.$route.params.id);
            this.userForm.displayName        = typeof undefined === typeof this.user.displayName ? null : user.displayName;
            this.userForm.email              = typeof undefined === typeof this.user.email ? null : user.email;
            this.userForm.id                 = typeof undefined === typeof this.user.id ? null : user.id;
            this.userForm.role               = typeof undefined === typeof this.user.role ? null : user.role;
            this.userForm.notificationMethod =
                typeof undefined === typeof user.notificationMethod ? false : user.notificationMethod;
            this.userForm.phoneNumber        = typeof undefined === typeof user.phoneNumber ? "" : user.phoneNumber;

            const title    = document.title.split(" | ");
            title[0]       = this.userForm.displayName;
            document.title = title.join(" | ");
        }
    },
    methods: {
        ...mapActions(
            "authentication",
            [
                "updateUser",
                "getUserAction",
                "getUsersAction"
            ]
        ),
        async submitForm() {
            await this.updateUser(this.userForm);
            await this.getUsersAction();

            this.$nextTick(
                () => {
                    if ( this.isUserAdmin ) {
                        this.$router.push({name: "users"})
                    } else {
                        this.$router.push({name: "dashboard"})
                    }
                }
            );
        }
    }
};
</script>